import request from '@/utils/request'

export function login(username, password, totpCode = '') {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password,
      totpCode   // MFA未启用时传空字符串，后端会忽略
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
// ---------- MFA ----------

export function getMfaSetup(adminId) {
  return request({
    url: '/admin/mfa/setup',
    method: 'get',
    params: { adminId }
  })
}

export function activateMfa(adminId, totpCode) {
  return request({
    url: '/admin/mfa/activate',
    method: 'post',
    params: { adminId, totpCode }
  })
}
// ---------- Account Management ----------

export function unlockAdmin(id) {
  return request({
    url: '/admin/unlock/' + id,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js